import axios from "axios"

const paramsSerializer = (params) => {
  const Qs = require("qs")
  return Qs.stringify(params, { encode: false })
}

export const findPersons = (headers, params) => {
  return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/persons`, {
    headers,
    params,
    paramsSerializer
  })
}

export const findPersonInfo = (headers) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/myself`,
    {
      headers
    },
    { useCache: false }
  )
}

export const changePwd = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/change-pwd`,
    data,
    {
      headers
    }
  )
}

export const getOTPPhone = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/change-phone/generate-otp`,
    data,
    {
      headers
    }
  )
}

export const verifyChangePhone = (headers, data) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/change-phone/verification`,
    data,
    {
      headers
    }
  )
}

export const getOTPEmail = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/change-email/generate-otp`,
    data,
    {
      headers
    }
  )
}

export const verifyChangeEmail = (headers, data) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/change-email/verification`,
    data,
    {
      headers
    }
  )
}

export const firstLogin = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/first-login`,
    data,
    {
      headers
    }
  )
}

export const getMembersByClientId = (headers, id, params) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/find-member`,
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const getMembersByClientIdNot = (headers, idOrg, params) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${idOrg}/find-member/not`,
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const disableClientId = (headers, orgId, params) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${orgId}/disable-clients-org`,
    {},
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const enableClientId = (headers, orgId, params) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${orgId}/enable-clients-org`,
    {},
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const activeSmartOTP = (headers, id) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/active-smart-otp`,
    {},
    {
      headers
    }
  )
}

export const findClientsById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/find-clients`,
    {
      headers
    },
    { useCache: false }
  )
}

export const findClientsOrg = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/find-clients-org`,
    {
      headers
    },
    { useCache: false }
  )
}

export const findDivices = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/find-device-smart-otp`,
    {
      headers
    }
  )
}

export const deleteDevices = (headers, id, params) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/delete-device-smart-otp`,
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const verifyEmailPhone = (headers, id) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/verify/${id}/confirm`,
    {},
    {
      headers
    }
  )
}

export const getOtpAddEmailApi = (headers, email) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/update-email/generate-otp?email=${email}`,
    {},
    {
      headers
    }
  )
}

export const getOtpAddPhoneApi = (headers, phone) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/update-phone/generate-otp?phone=${phone}`,
    {},
    {
      headers
    }
  )
}

export const confirmEmail = (headers, email, otp) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/update-email/verification?email=${email}&otp=${otp}`,
    {},
    {
      headers
    }
  )
}

export const confirmPhone = (headers, phone, otp) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/update-phone/verification?phone=${phone}&otp=${otp}`,
    {},
    {
      headers
    }
  )
}

export const getLoginInformationLogin = (headers, appId) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/get-login-information-login?appId=${appId}`,
    {
      headers
    },
    { useCache: false }
  )
}